<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="書類アップロード"
        hide-footer
        @hidden="close">
        <div class="modal-body">
            <template v-if="!nextModal">
                <div
                    class="alert alert-info mb-4"
                    style="position: static; width: 100%; transform: none;">
                    <b-icon-info-circle-fill/>
                    {{ $locale.consultation_host }}予約には、渡航期間を証明できる書類のアップロードを事前に行なっていただく必要があります。
                </div>
                <div class="form-group m-form__group file-upload">
                    <label for="document is-required-ja">
                        <span class="d-block is-required-ja-self">書類のアップロード</span>
                    </label>
                    <div id="c-upload" class="c-upload">
                        <div class="input-group input-profile-image-wrapper">
                            <b-form-file
                                v-model="file"
                                ref="fileinput"
                                accept="image/jpeg, image/png, image/gif, application/pdf"
                                placeholder="選択してください（ファイル形式: jpg, png, gif, pdf）"
                                @change="bindSelectedImage"
                                :class="{ 'is-invalid' : errors.file }">
                            </b-form-file>
                        </div>
                        <div class="mt-3">
                            <div v-if="uploadImage.base64 !== null">
                                <img class="uploadImage" :src="uploadImage.base64">
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="errors.file"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.file[0] }}
                    </div>
                    <div class="example">
                        <div>【渡航期間を証明できる書類の例】</div>
                        <ul class="d-flex">
                            <li>日程表</li>
                            <li>航空券の写し&nbsp;など</li>
                        </ul>
                    </div>
                </div>
                <button 
                    class="btn btn-yokumiru-orange upload-btn d-flex"
                    @click="onUpload">
                    アップロード
                </button>

            </template>
            <template v-if="nextModal">
                <span class="close-modal-text">書類のアップロードが完了しました</span>
                <div slot="modal-footer">
                    <button
                        class="btn btn-yokumiru-gray mr-2 float-right"
                        :disabled="inProgress"
                        @click="close">
                        閉じる
                    </button>
                </div>
            </template>
        </div>

        <!-- loader -->
        <div
            v-show="inProgress"
            class="u-loader u-loader--p5 u-loader--full u-loader--full-under-modal">
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import moment from "moment-timezone";

    export default {
        props: {
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                uploadImage: {
                    name: null,
                    object: null,
                    base64: null,
                },
                errors: {},
                nextModal: false,
                file: null,
            }
        },

        computed: {
        },

        created: function () {
            bus.$on('open-modal-subscription-file-upload', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-subscription-file-upload')
        },

        methods: {
            /**
             * モーダルを表示
             */
            open: function() {
                this.initImage()
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false
                this.nextModal = false
            },

            /**
             * ファイル選択時処理
             *
             * @return {void}
             */
            bindSelectedImage: function(e) {
                const elem = e.target
                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10485760) {
                        this.errors = { file: ['ファイルサイズは10MB以内にしてください。'] }
                        setTimeout(() => this.initImage(), 100)
                        return
                    }

                    this.uploadImage.object = elem.files[0]
                    this.uploadImage.name = this.uploadImage.object.name

                    if (elem.files[0].type !== 'application/pdf') {
                        const fr = new FileReader()
                        fr.onload = () => { this.uploadImage.base64 = fr.result }
                        fr.readAsDataURL(this.uploadImage.object)
                    } else {
                        this.uploadImage.base64 = null
                    }
                } else {
                    this.initImage()
                }
            },

            /**
             * 状態初期化
             */
            initImage: function() {
                this.file = null
                this.uploadImage = {
                    name: null,
                    object: null,
                    base64: null,
                }
            },

            /**
             * 書類をアップロード
             */
            onUpload: async function () {
                if(this.inProgress) return
                this.inProgress = true
                this.errors = {}

                const req = this.prepareRequest()
                const endpoint = `${constants.user.subscriptions.endpoint.base}/upload`

                await axios.post(endpoint, req.formData, req.config)
                    .then(({}) => {
                        this.nextModal = true
                        bus.$emit('subscription-document-uploaded')
                    })
                    .catch(({response}) => {
                        if (
                            response
                            && response.hasOwnProperty('data')
                            && response.data
                            && response.data.hasOwnProperty('errors')
                            && response.data.errors
                        ) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger', '書類をアップロードできませんでした。')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。サポートセンターまでお問い合わせください。')
                        }
                        this.inProgress = false
                        this.nextModal = false
                    })

                this.inProgress = false
            },

            prepareRequest: function () {
                let formData = new FormData()
                
                formData.append('file', this.file)

                return {
                    formData: formData,
                    config: {
                        headers: { 'content-type': 'multipart/form-data' },
                    },
                }
            },
        },
    }
</script>

<style scoped>
.example {
    margin-bottom: 20px;
    color: #5e5e5e;
    font-size: 12px;

    ul {
        padding-left: 20px;

        li {
            padding-right: 20px;
        }
    }
}

.upload-btn {
    margin: 0 auto 0 auto;
    width: 50%;
    justify-content: center;
}

.close-modal-text {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5em 0 5em 0;
    font-size: 18px;
}
</style>
